let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a7vEw")).then(() => parcelRequire('anqDN'));